import styled from '@emotion/styled';
import { Button, colors, Input, Text } from '@innovationdepartment/proxima-ui';
import { useState } from 'react';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  min-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
  margin-bottom: 20px;
`;

const ModalTitle = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  color: ${colors.neutral80};
`;

const ModalBody = styled.div`
  margin-bottom: 24px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

interface AddNewCategoryModalProps {
  show: boolean;
  type: 'category' | 'subcategory';
  onCancel: () => void;
  onSubmit: (value: string) => void;
}

const AddNewCategoryModal = ({ show, type, onCancel, onSubmit }: AddNewCategoryModalProps) => {
  const [value, setValue] = useState('');

  if (!show) return null;

  const handleSubmit = () => {
    const trimmedValue = value.trim();
    if (trimmedValue) {
      onSubmit(trimmedValue);
      setValue('');
    }
  };

  const handleCancel = () => {
    setValue('');
    onCancel();
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && value.trim()) {
      handleSubmit();
    }
  };

  const title = type === 'category' ? 'Enter New Category' : 'Enter New Sub-Category';

  return (
    <ModalOverlay onClick={handleCancel}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle variant="h6">{title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Input
            fullWidth
            value={value}
            onChange={newValue => setValue(newValue as string)}
            onKeyPress={handleKeyPress}
            placeholder={`Enter ${type} name`}
          />
        </ModalBody>
        <ModalFooter>
          <Button label="Cancel" size="small" onClick={handleCancel} variant="text" />
          <Button label="Submit" size="small" onClick={handleSubmit} disabled={!value.trim()} />
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AddNewCategoryModal;
